<template>
  <div class="home-container">
    <div class="home-main-content">
      <div class="main-content">
        <el-row class="home-top-content" :gutter="24" type="flex">
          <el-col :span="8" class="home-top-item">
            <img
              class="home-logo"
              src="../assets/logo.png"
              alt=""
              srcset=""
              width="80%"
            />
            <h1 class="text-logo">C-GRAN</h1>
            <p>
              Community-Guided Recursive Annotation Network for Emerging
              Compounds Discovery
            </p>
          </el-col>
          <el-col :span="16" class="home-link-list">
            <section class="link-item">
              <h2 class="link-title">
                C-GRAN Web
                <i class="iconfont el-icon-d-arrow-right" @click="routerTo('web')"></i>
              </h2>
              <p>
                Use C-GRAN directly from your browser for a visual, interactive
                experience. Great for beginners or exploring your data. (<span
                  class="tips"
                  >Naive Annotation</span
                >)
              </p>
            </section>
            <section class="link-item">
              <h2 class="link-title">
                C-GRAN CL
                <i class="iconfont el-icon-d-arrow-right" @click="linkTo('https://github.com/JeremyChou28/C_GRAN')"></i>
              </h2>
              <p>
                Use the C-GRAN command line tool for batch processing and
                annotation with in silico tool CFM-ID. (<span class="tips"
                  >Annotation with CFM-ID</span
                >)
              </p>
            </section>
          </el-col>
        </el-row>
      </div>

      <div class="home-divider">
        <p>Welcome to C-GRAN 1.0!</p>
        <div class="divider-line"></div>
      </div>
      <div class="main-content home-bottom-content">
        <div class="bottom-content-item">
          <h3>Overview</h3>
          <p>
            C-GRAN (Community-Guided Recursive Annotation Network) is an open,
            network-based framework for the systematic discovery and annotation
            of emerging structural analogs in complex environmental samples.
            Designed for non-target screening (NTS) using tandem mass
            spectrometry (MS/MS), C-GRAN integrates molecular networking with
            sample-wise co-occurrence analysis to uncover structurally or
            functionally related compounds beyond spectral similarity
            constraints. Starting from high-confidence seed annotations,
            candidate compounds are expanded through a recursive database search
            strategy, incorporating exact-mass-based matching. Each candidate is
            ranked based on structural similarity to known analogs, fragment
            match quality, and occurrence correlation. By iteratively
            propagating annotations across molecular networks, C-GRAN enables
            high-coverage identification of structurally diverse
            compounds—especially those missed by traditional spectral-based
            tools.
          </p>
        </div>
        <div class="bottom-content-item">
          <h3>Please cite:</h3>
          <p>XXX</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
    data() {
        return {}
    },
    methods: {
        routerTo(name) {
            this.$router.push({
                name
            })
        },
        linkTo(url) {
          window.open(url, '_blank')
        }
    }
};
</script>
<style lang="less" scoped>
.home-main-content {
  margin: auto;
  max-width: 1680px;
  padding: 48px 0;
  //   .main-content {
  //     max-width: 1440px;
  //     margin: auto;
  //   }
  .home-top-item {
    text-align: center;
    .text-logo {
      color: #ffc000;
      font-weight: 700;
      text-shadow: 2px 2px 3px rgba(0, 0, 0, 0.3);
      font-family: system-ui, Avenir, Helvetica, Arial, sans-serif;
      font-size: 48px;
      font-style: italic;
      margin-left: -10%;
      text-align: center;
    }
    p {
      margin-top: 12px;
      font-size: 18px;
      font-weight: 600;
      text-align: center;
      text-shadow: 2px 2px 3px rgba(0, 0, 0, 0.3);
      padding-right: 10%;
      line-height: 22px;
      //   padding-right: 12px;
    }
  }
  .home-link-list {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }
  .link-item {
    .link-title {
      text-align: left;
      font-weight: 700;
      font-size: 42px;
      font-family: system-ui, Avenir, Helvetica, Arial, sans-serif;
      margin-bottom: 16px;
      display: flex;
      align-items: center;
      .iconfont {
        padding: 6px 18px;
        font-size: 18px;
        background: #2e75b6;
        border-radius: 6px;
        color: #fff;
        font-weight: 700;
        vertical-align: middle;
        margin-left: 12px;
        &:hover {
            cursor: pointer;
            background: #0080c0;
        }
      }
    }
    p {
      font-family: system-ui, Avenir, Helvetica, Arial, sans-serif;
      font-size: 20px;
      line-height: 28px;
      .tips {
        color: #ed7d31;
        font-weight: 500;
      }
    }
  }
  .home-divider {
    margin: 56px 0;
    p {
      font-family: system-ui, Avenir, Helvetica, Arial, sans-serif;
      font-size: 24px;
      font-weight: 700;
      font-style: italic;
      margin-bottom: 6px;
    }
    .divider-line {
      height: 6px;
      background: #ed7d31;
    }
  }
  .bottom-content-item {
    margin-bottom: 36px;
    padding: 0 12px;
    h3 {
      font-family: system-ui, Avenir, Helvetica, Arial, sans-serif;
      font-size: 26px;
      font-weight: 700;
      margin-bottom: 12px;
    }
    p {
      font-family: system-ui, Avenir, Helvetica, Arial, sans-serif;
      font-size: 19px;
      line-height: 24px;
      text-align: justify;
      // font-weight: 500;
    }
  }
}
</style>